import ClientLogged from './ClientLogged';

export default ClientLogged;
